import loginbg from "../assets/bg-pattern-light.svg";
export const AlmataMainLogo = "https://washi.s3.amazonaws.com/Almata-blue.png";

export default {
    loginbg,
    AlmataMainLogo
}